<script setup lang="ts"></script>

<template>
    <svg
        width="200"
        height="44"
        viewBox="0 0 200 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_245_5120)">
            <path
                d="M67.0482 19.9482L63.2295 17.1837L72.5796 4.54498L81.7327 16.9206L77.914 19.6851L72.5803 12.51L67.0496 19.9482H67.0482ZM91.149 23.2403V36.7351H76.3329V23.2403H91.149ZM81.0741 32.3899H86.4078V27.584H81.0741V32.3899ZM86.4732 20.6727V4.08423H91.346V20.6727H86.4732Z"
                fill="#FF6971"
            />
            <path
                d="M106.038 35.6476C103.555 35.6476 101.534 33.6278 101.534 31.145C101.534 28.6623 103.555 26.6432 106.038 26.6432C108.522 26.6432 110.541 28.663 110.541 31.145C110.541 33.627 108.521 35.6476 106.038 35.6476ZM106.038 28.8542C104.732 28.8542 103.747 29.839 103.747 31.145C103.747 32.4511 104.732 33.4358 106.038 33.4358C107.345 33.4358 108.33 32.4511 108.33 31.145C108.33 29.839 107.345 28.8542 106.038 28.8542ZM110.146 25.0237H107.934V15.3875H110.146V19.1396H113.307V21.3513H110.146V25.0244V25.0237ZM96.847 24.4832L95.0977 23.0844L98.8229 17.7573H95.4104V15.5456H104.536V17.7573H101.087L104.815 23.001L103.067 24.3998L99.9604 19.9633L96.8463 24.4839L96.847 24.4832Z"
                fill="white"
            />
            <path
                d="M126.609 38.0196H118.194V30.7928H124.198V27.9492H117.957V25.7375H126.411V33.0038H120.406V35.8079H126.609V38.0196ZM130.046 22.8148H114.362V20.6031H130.046V22.8148ZM122.223 18.0362C119.74 18.0362 117.72 16.0344 117.72 13.5739C117.72 11.1135 119.741 9.15112 122.223 9.15112C124.706 9.15112 126.767 11.135 126.767 13.5739C126.767 16.0128 124.729 18.0362 122.223 18.0362ZM122.223 11.3622C120.96 11.3622 119.932 12.3548 119.932 13.5739C119.932 14.793 120.938 15.8252 122.223 15.8252C123.508 15.8252 124.554 14.7937 124.554 13.5739C124.554 12.4166 123.444 11.3622 122.223 11.3622Z"
                fill="white"
            />
            <path
                d="M146.151 4.17481V8.71692H137.195V15.102H146.348V19.5787H132.323V4.17481H146.151ZM155.37 22.6717V35.5742H145.361V39.5233H155.37V44H140.488V31.2291H150.496V27.2138H140.422V22.6717H155.37ZM155.37 20.1703H150.497V3.58252H155.37V9.70455H160.309V14.1805H155.37V20.171V20.1703Z"
                fill="#FF6971"
            />
            <path
                d="M179.32 32.8788H176.95V18.134H179.32V24.3876H184.654V26.7575H179.32V32.8795V32.8788ZM170.694 32.1543H158.842V18.8579H170.496V21.2278H161.212V29.7858H170.693V32.155L170.694 32.1543Z"
                fill="white"
            />
            <path
                d="M44.3245 36.0522H42.112V31.234H35.9098V29.0223H44.3245V36.0522ZM44.3245 27.1261H42.112V17.4898H44.3245V21.242H47.4853V23.4537H44.3245V27.1268V27.1261ZM34.6853 26.9284C32.1824 26.9284 30.2216 24.9855 30.2216 22.5056C30.2216 20.0258 32.1824 18.1217 34.6853 18.1217C37.1882 18.1217 39.1885 20.0883 39.1885 22.5056C39.1885 24.923 37.1681 26.9284 34.6853 26.9284ZM34.6853 20.3334C33.4018 20.3334 32.4333 21.2679 32.4333 22.5056C32.4333 23.7434 33.4011 24.7174 34.6853 24.7174C35.9695 24.7174 36.9768 23.7247 36.9768 22.5056C36.9768 21.2865 35.9278 20.3334 34.6853 20.3334ZM39.4653 17.0557H29.8262V14.8439H33.5794V12.2375H35.7919V14.8439H39.4661V17.0557H39.4653Z"
                fill="white"
            />
            <path
                d="M68.3758 35.8638H66.1634V26.2671H68.3758V35.8638ZM63.1212 35.8638H60.9088V32.1907H58.449C57.8946 34.0424 56.1014 35.4289 54.0745 35.4289C51.591 35.4289 49.5713 33.4271 49.5713 30.9666C49.5713 28.5062 51.5917 26.5438 54.0745 26.5438C56.2316 26.5438 58.042 28.0138 58.5037 29.9797H60.9088V26.2671H63.1212V35.8638ZM54.0745 28.7556C52.8112 28.7556 51.783 29.7482 51.783 30.9673C51.783 32.1864 52.7896 33.2186 54.0745 33.2186C55.3594 33.2186 56.4056 32.1871 56.4056 30.9673C56.4056 29.8101 55.2947 28.7556 54.0745 28.7556Z"
                fill="white"
            />
            <path
                d="M0 29.2043V24.7276H26.6684V29.2043H15.804V34.6018H10.9312V29.2043H0ZM6.91336 20.8439L3.42325 17.684L13.3011 6.69141L23.1783 17.684L19.6882 20.8439L13.3011 13.6688L6.91408 20.8439H6.91336Z"
                fill="#FF6971"
            />
            <path
                d="M189.095 4.50545C189.095 4.50545 185.025 0.249424 180.58 3.34818C175.636 6.79627 179.273 12.2707 183.343 16.1529C186.664 19.3207 188.758 22.014 189.094 22.6487V4.50545H189.095Z"
                fill="#FF6971"
            />
            <path
                d="M189.098 4.50545C189.098 4.50545 193.168 0.249424 197.612 3.34818C202.557 6.79627 198.919 12.2707 194.849 16.1529C191.529 19.3207 189.434 22.014 189.098 22.6487V4.50545H189.098Z"
                fill="#D1D5D8"
            />
            <path
                d="M189.098 4.50538C189.098 4.50538 192.924 -1.31835 195.892 1.78041C199.193 5.2285 195.656 12.2706 192.937 16.1536C190.72 19.3213 189.322 22.0147 189.098 22.6494V4.50538Z"
                fill="#85898A"
            />
            <path
                d="M189.098 4.50547C189.098 4.50547 191.284 -2.28864 192.643 0.809393C194.155 4.25748 192.1 12.2707 190.856 16.1529C189.84 19.3207 189.2 22.014 189.098 22.6487V4.50547Z"
                fill="#2F2F31"
            />
        </g>
        <defs>
            <clipPath id="clip0_245_5120">
                <rect width="200" height="44" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
